module.exports = __webpack_public_path__ + "static/media/marsden_bs.c798b5cd.png";